import { useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import Product from "./Product";

function ProductDetails(){
    const api_url ="https://fakestoreapi.com/products";
    const [product,setProduct]= useState({});
    
    const prams =useParams();
    useEffect(()=>{
        fetch(`${api_url}/${prams.productId}`)
            .then(res=>res.json())            
            .then(product=>setProduct(product));
    },[]);
    return(
        <Product Product={product} showButton={false} />
    )
}
export default ProductDetails;